module.exports = __webpack_public_path__ + "img/landing2.3fdf3fb1.png";